import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { useTable, useGlobalFilter, usePagination, useSortBy, useRowSelect, Column, UseSortByColumnOptions, TableOptions, UseFiltersOptions, CellProps, Cell, HeaderProps, FilterProps, TableProps } from "react-table";

import { Container, Row, Col, Table, Input, Button } from "reactstrap";
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';

import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import SelectItem from 'components/Varios/select';

import Datepicker from 'components/Varios/Datepicker';
import { classNameIconoLupa, classNameOjos } from 'constants/Icons-Font-Awesome';
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import { CustomStyleColumn } from 'components/Types/GeneralTypes';
import { PersonalAprobarDetalleMarcacion } from './TypePersonalAprobarMarcacion';
import { listadoMeses } from 'functions/DatesFunctions';




type PropsTablaPersonalAprobar = {
    informacion: PersonalAprobarDetalleMarcacion[],
    onClickVerMarcaciones: (idPersona: number, nombre: string, identificacion: string) => void
    onClickDescargarHojaMarcaciones:(identificacion:string,mesconsulta:number,fechaactual:string) => Promise<void>
    mesConsulta: number,
    fechaActual: string
}


export default function TablaPersonalMarcaciones(props: PropsTablaPersonalAprobar) {


    const informacion: PersonalAprobarDetalleMarcacion[] = useMemo(() =>
        [...props.informacion], [props.informacion]
    );



    const CellVerMarcaciones = (celda: CellProps<PersonalAprobarDetalleMarcacion, number>) => {


        const idPersona = celda.value;
        const nombre = celda.row.original.nombreCompleto;
        const identificacion = celda.row.original.numeroIdentificacion
        // return (
        //     <i className={`${classNameOjos} hover`} onClick={() => props.onClickVerMarcaciones(idPersona)} />
        // )


        return (
            <div>
                <div className='btnVerMarcaciones' onClick={() => props.onClickVerMarcaciones(idPersona, nombre, identificacion)}>Ver</div>
                <div className='btnVerMarcaciones' onClick={() => props.onClickDescargarHojaMarcaciones(identificacion,props.mesConsulta,props.fechaActual)}>Descargar Hoja</div>
            </div>

        )


    }


    type typeColumna = Column<PersonalAprobarDetalleMarcacion> & UseFiltersOptions<PersonalAprobarDetalleMarcacion> & {
        headerProps?: { rowSpan?: number; colSpan?: number };
    };


    const columnas = useMemo<readonly typeColumna[]>(() => [
        {
            Header: '#',
            accessor: (originalrow, index) => index + 1,
            disableSortBy: true,
            disableGlobalFilter: true,
            headerProps: { rowSpan: 2 },

        },
        {
            Header: "Identificación",
            accessor: "numeroIdentificacion",
            headerProps: { rowSpan: 2 },
        },
        {
            Header: "Nombre Completo",
            accessor: "nombreCompleto",
            headerProps: { rowSpan: 2 },
        },
        // {
        //     Header: "Numero Identificación",
        //     accessor: "numeroidentificacion"
        // },
        //{
        //    Header: "Unidad",
        //    accessor: "unidad"
        //},
        {
            Header: "Régimen",
            accessor: "regimen",
            headerProps: { rowSpan: 2 },
        },
        {
            Header: `Incidencias del mes de ${listadoMeses.find(v => v.valorMes === props.mesConsulta)?.mes}`,
            columns: [
                {
                    Header: "Total",
                    accessor: "detalleIncidencia.totalNovedades"
                },
                {
                    Header: "Entrada",
                    accessor: "detalleIncidencia.novedadesIngreso"
                },
                {
                    Header: "Salida",
                    accessor: "detalleIncidencia.novedadesSalida"
                },
                {
                    Header: "Receso",
                    accessor: "detalleIncidencia.novedadesReceso"
                }
            ]
        },
        // {
        //     Header: "Cargo",
        //     accessor: "cargo"
        // },
        {
            Header: "Marcaciones",
            accessor: "idPersona",
            headerProps: { rowSpan: 2 },
            Cell: (celda: CellProps<PersonalAprobarDetalleMarcacion, number>) => {
                return CellVerMarcaciones(celda);
            }
        }
    ], [props.informacion])

    const columnasStyles = (cell: Cell<PersonalAprobarDetalleMarcacion>): CustomStyleColumn[] => {


        const estilos: CustomStyleColumn[] = [
            {
                HeaderName: "#",
                StyleHeader: {
                    textAlign: "center",
                    width: "50px",
                    padding: "0px"
                },

            },
            {
                HeaderName: "Identificación",
                StyleHeader: {
                    textAlign: "center",
                    width: "100px"
                }
            },
            {
                HeaderName: "Nombre Completo",
                StyleHeader: {
                    textAlign: "left",
                    width: "200px",
                    paddingLeft: "10px"
                }
            },

            {
                HeaderName: "Régimen",
                StyleHeader: {
                    textAlign: "center",
                    width: "100px"
                }
            },
            {
                HeaderName: "Total",
                StyleHeader: {
                    textAlign: "center",
                    width: "50px"
                }
            },
            {
                HeaderName: "Entrada",
                StyleHeader: {
                    textAlign: "center",
                    width: "50px"
                }
            },
            {
                HeaderName: "Salida",
                StyleHeader: {
                    textAlign: "center",
                    width: "50px"
                }
            },
            {
                HeaderName: "Receso",
                StyleHeader: {
                    textAlign: "center",
                    width: "50px"
                }
            },
            {
                HeaderName: "Marcaciones",
                StyleHeader: {
                    textAlign: "center",
                    width: "120px"
                }
            }
        ]

        return estilos;
    }


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        visibleColumns,
        prepareRow,
        setColumnOrder,
        allColumns,
        state,
        setGlobalFilter,

    } = useTable(
        {
            data: informacion,
            columns: columnas,
            autoResetSortBy: false,
            autoResetHiddenColumns: false,
            autoResetGlobalFilter: false,
            initialState: {
                pageSize: 20
            }

        },
        useGlobalFilter,
        useSortBy,
        usePagination,
    )


    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = informacion.length;


    const alteredpage = page.map((row, indice) => {
        row.values = { ...row.values, "#": indice + 1 }

        return row;

    })


    const sizedMDCol = 11;
    const sizeXLCol = 9;


    return (
        <React.Fragment>
            <Container fluid>
                <Row className="">
                    <Col md={sizedMDCol} xl={sizeXLCol} className="ml-auto mr-auto mb-1">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />
                    </Col>
                </Row>
            </Container>

            <Container fluid>
                <Row className="">
                    <Col md={sizedMDCol} xl={sizeXLCol} className="ml-auto mr-auto">
                        <div className="table-responsive">
                            <Table responsive className={"tablesReact"}  {...getTableProps()} style={{ border: 'solid 1px ' }} >
                                <thead>
                                    {/* Primera fila: Columnas principales */}
                                    <tr className="trPersonalAprobarMarcaciones">
                                        {headerGroups[0].headers.map((column, i) => {
                                            // Detectar si la columna tiene subcolumnas
                                            const isParent = (column).columns;

                                            // Configurar propiedades para colspan y rowspan
                                            const headerProps = isParent
                                                ? { colSpan: isParent.length } // Si tiene subcolumnas, usar colSpan
                                                : { rowSpan: 2 }; // Si no tiene subcolumnas, usar rowSpan


                                            if (isParent) {
                                                return (
                                                    <th
                                                        className={"thPersonalAprobarMarcaciones"}
                                                        {...column.getHeaderProps({
                                                            ...column.getSortByToggleProps(),
                                                        })}
                                                        {...headerProps}
                                                    >
                                                        {column.render('Header')}
                                                        {/* Mostrar ícono de ordenamiento */}
                                                        <span>
                                                            {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                                        </span>
                                                    </th>
                                                );
                                            }
                                            else {

                                                const flatColumn = headerGroups[1].headers.find(
                                                    header => header.id === column.headers[0].id
                                                );
                                                if (flatColumn) {
                                                    return (
                                                        <th
                                                            className={"thPersonalAprobarMarcaciones"}
                                                            {...flatColumn.getHeaderProps({
                                                                ...flatColumn.getSortByToggleProps(),
                                                            })}
                                                            {...headerProps}
                                                        >
                                                            {flatColumn.render('Header')}
                                                            <span>
                                                                {flatColumn.isSorted ? (flatColumn.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                                            </span>
                                                        </th>
                                                    );
                                                }

                                                return null;
                                            }

                                        })}
                                    </tr>

                                    {/* Segunda fila: Subcolumnas */}
                                    <tr className="trPersonalAprobarMarcaciones">
                                        {headerGroups[0].headers
                                            .filter(column => Array.isArray((column).columns)) // Filtrar columnas con subcolumnas
                                            .flatMap(column => (column).columns || []) // Obtener subcolumnas, asegurando que no sean undefined
                                            .map(subColumn => (
                                                <th
                                                    className={"thPersonalAprobarMarcaciones"}
                                                    {...subColumn.getHeaderProps({
                                                        ...subColumn.getSortByToggleProps(),
                                                    })}
                                                >
                                                    {subColumn.render('Header')}
                                                    {/* Mostrar ícono de ordenamiento */}
                                                    <span>
                                                        {subColumn.isSorted ? (subColumn.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                                    </span>
                                                </th>
                                            ))}
                                    </tr>
                                </thead>

                                <tbody {...getTableBodyProps()}>
                                    {alteredpage.map((row, indirow) => {
                                        prepareRow(row)
                                        return (
                                            <tr className={"rowPersonalAprobar"} {...row.getRowProps()}>
                                                {row.cells.map(cell => {
                                                    return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))
                                                })}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>



                        <ComponentePaginacionTabla
                            page={alteredpage}
                            sizerows={sizerows}
                            canNextPage={canNextPage}
                            canPreviousPage={canPreviousPage}
                            nextPage={nextPage}
                            pageIndex={pageIndex}
                            pageOptions={pageOptions}
                            pageSize={pageSize}
                            previousPage={previousPage}
                            setPageSize={setPageSize}

                        />
                    </Col>
                </Row>
            </Container>

        </React.Fragment>



    )
}
